import styled from '@emotion/styled'

// Tokenized table primitives shared across studio + platform (KAT-297). Wrap a
// <Table> in <TableScroll> so it scrolls horizontally on narrow screens instead
// of overflowing the layout.
export const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`

export const Th = styled.th`
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--c-fg-subtle);
  padding: 10px 14px;
  border-bottom: 1px solid var(--c-border);
  white-space: nowrap;
`

export const Td = styled.td`
  padding: 12px 14px;
  border-bottom: 1px solid var(--c-border);
  color: var(--c-fg);
  vertical-align: middle;
`

export const Tr = styled.tr`
  transition: background var(--d-fast) var(--ease-standard);

  &:hover td {
    background: var(--c-bg-sunk);
  }
`
